import { useTranslation } from 'react-i18next';
import Button from '@components/atoms/ui-kit/button.tsx';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';

export const LiveRecordingPreview = ({
  text,
  close
}: {
  text: string;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();
  const download = () => {
    const url = URL.createObjectURL(
      new Blob([text], { type: 'text/plain;charset=utf-8' })
    );
    const link = document.createElement('a');
    link.href = url;
    link.download = 'recording-generated-version.txt';
    link.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm">{t('live-recording-review-help')}</p>
      <textarea
        readOnly
        aria-label={t('live-generated-version')}
        value={text}
        className="border rounded-lg p-3 min-h-40"
        style={{
          backgroundColor: getColour('baseLayer'),
          color: getColour('normalText'),
          borderColor: getColour('border')
        }}
      />
      <div className="flex gap-2">
        <Button size="small" label={t('export')} onClick={download} />
        <Button
          variant="outline"
          size="small"
          label={t('close')}
          onClick={close}
        />
      </div>
    </div>
  );
};
